import React, { useState } from 'react';
import { Snackbar, SnackbarContent } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import PropTypes from 'prop-types';
import { ToastContext } from './index';
import ToastMessage from './ToastMessage';
import { toastTypes, anchorToast } from './ToastOptions';


const useStyles = makeStyles({
  wrapper: {
    backgroundColor: (props) => props?.backgroundcolor,
    flexDirection: 'column',
    alignItems: 'center'
  }
});

const handleClose = (set) => () => set(null);

const show = (set) => (message, {
  defaultMessage, ...rest
}, id) => {
  const toast = {
    content: message || defaultMessage, id, ...rest
  };

  set(toast);
};

const ToastProvider = ({ children }) => {
  const [toast, setToast] = useState();
  const classes = useStyles({ ...toast });
  const showToast = show(setToast);

  const success = (message) => showToast(message, toastTypes.success);
  const error = (message, id) => showToast(message, toastTypes.error, id);
  const warning = (message) => showToast(message, toastTypes.warning);

  const {
    type, content, Icon, backgroundcolor, id = ''
  } = toast || {};

  return (
    <ToastContext.Provider value={{ success, error, warning }}>
      {children}
      {toast && (
        <Snackbar
          key={id || type}
          open={Boolean(toast)}
          anchorOrigin={anchorToast}
          autoHideDuration={6000}
          backgroundcolor={backgroundcolor}
          onClose={handleClose(setToast)}
        >
          <SnackbarContent
            className={classes.wrapper}
            message={(<ToastMessage content={content} Icon={Icon} id={id} />)}
          />

        </Snackbar>
      )}
    </ToastContext.Provider>
  );
};

ToastProvider.propTypes = {
  children: PropTypes.node
};

export default ToastProvider;
